import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../../generic/Modal';

interface Props {
  onDelete: () => void;
}

export const CommentDeleteModal = createModal<Props>((props) => {
  const { modal, onDelete } = props;
  const { visible, hide, remove } = modal;

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove}>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle title='Do you want to delete this comment?' />
          <ChakraV3.Dialog.Footer>
            <ChakraV3.HStack>
              <ChakraV3.Button key='close' onClick={hide} variant='subtle' size='sm'>
                Close
              </ChakraV3.Button>
              <ChakraV3.Button
                onClick={() => {
                  onDelete();
                  hide();
                }}
                key='submit'
                colorPalette='red'
                type='submit'
                size='sm'
              >
                Delete
              </ChakraV3.Button>
            </ChakraV3.HStack>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
